var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    attrs: {
      "action": ""
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('b-card', [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-user'></i> Identitas Diri"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nama Ekspedisi"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.namaLengkap),
      expression: "headerTransit.namaLengkap"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Nama Ekspedisi",
      "id": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.headerTransit.namaLengkap = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.loadIdPerusahaan()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.dataPerusahaan), function(nama) {
    return _c('option', {
      domProps: {
        "value": nama.NAMA_PERUSAHAAN
      }
    }, [_vm._v(" " + _vm._s(nama.NAMA_PERUSAHAAN) + " ")])
  })], 2), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nama Ekspedisi')),
      expression: "errors.has('Nama Ekspedisi')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Nama Ekspedisi')) + " ")])]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Nama Kurir"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.namaKurir),
      expression: "headerTransit.namaKurir"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Nama Kurir",
      "type": "text"
    },
    domProps: {
      "value": (_vm.headerTransit.namaKurir)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.namaKurir = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nama Kurir')),
      expression: "errors.has('Nama Kurir')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Nama Kurir')) + " ")])]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Kota Asal"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.kotaAsal),
      expression: "headerTransit.kotaAsal"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Kota Asal",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.headerTransit.kotaAsal = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.refKota), function(kota) {
    return _c('option', {
      domProps: {
        "value": kota.NAMA_KOTA
      }
    }, [_vm._v(" " + _vm._s(kota.NAMA_KOTA) + " ")])
  })], 2), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Kota Asal')),
      expression: "errors.has('Kota Asal')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Kota Asal')) + " ")])]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Kota Tujuan"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.kotaTujuan),
      expression: "headerTransit.kotaTujuan"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Kota Tujuan",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.headerTransit.kotaTujuan = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.refKota), function(kota) {
    return _c('option', {
      domProps: {
        "value": kota.NAMA_KOTA
      }
    }, [_vm._v(" " + _vm._s(kota.NAMA_KOTA) + " ")])
  })], 2), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Kota Tujuan')),
      expression: "errors.has('Kota Tujuan')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Kota Tujuan')) + " ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Pelabuhan Kedatangan"
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.pelKedatangan),
      expression: "headerTransit.pelKedatangan"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "PelKedatanganForm",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.headerTransit.pelKedatangan = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Batu Ampar"
    }
  }, [_vm._v("Batu Ampar")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Warehouse Hang Nadim"
    }
  }, [_vm._v("Warehouse Hang Nadim")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Terminal Hang Nadim"
    }
  }, [_vm._v("Terminal Hang Nadim")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Telaga Punggur"
    }
  }, [_vm._v("Telaga Punggur")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Roro Punggur"
    }
  }, [_vm._v("Roro Punggur")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Domestik Sekupang"
    }
  }, [_vm._v("Domestik Sekupang")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Harbour Bay"
    }
  }, [_vm._v("Harbour Bay")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Nongsa Pura"
    }
  }, [_vm._v("Nongsa Pura")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Batam Center"
    }
  }, [_vm._v("Batam Center")])]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('PelKedatanganForm')),
      expression: "errors.has('PelKedatanganForm')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('PelKedatanganForm')) + " ")])]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Pelabuhan Keberangkatan"
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.pelKeberangkatan),
      expression: "headerTransit.pelKeberangkatan"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "PelKeberangkatanform",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.headerTransit.pelKeberangkatan = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Batu Ampar"
    }
  }, [_vm._v("Batu Ampar")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Warehouse Hang Nadim"
    }
  }, [_vm._v("Warehouse Hang Nadim")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Terminal Hang Nadim"
    }
  }, [_vm._v("Terminal Hang Nadim")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Telaga Punggur"
    }
  }, [_vm._v("Telaga Punggur")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Roro Punggur"
    }
  }, [_vm._v("Roro Punggur")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Domestik Sekupang"
    }
  }, [_vm._v("Domestik Sekupang")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Harbour Bay"
    }
  }, [_vm._v("Harbour Bay")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Nongsa Pura"
    }
  }, [_vm._v("Nongsa Pura")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Batam Center"
    }
  }, [_vm._v("Batam Center")])]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('PelKeberangkatanform')),
      expression: "errors.has('PelKeberangkatanform')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('PelKeberangkatanform')) + " ")])]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Tanggal Perkiraan Pengeluaran"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.tglPerkiraan),
      expression: "headerTransit.tglPerkiraan"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Tanggal Perkiraan",
      "type": "date",
      "locale": "en"
    },
    domProps: {
      "value": (_vm.headerTransit.tglPerkiraan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.tglPerkiraan = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Tanggal Perkiraan')),
      expression: "errors.has('Tanggal Perkiraan')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Tanggal Perkiraan')) + " ")])])], 1)])]), _vm._v(" "), _c('b-card', {
    attrs: {
      "header": "<i class='fa fa-cube'></i> Data Kemasan"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jumlah Kemasan"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.jumlahKemasan),
      expression: "headerTransit.jumlahKemasan"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Jumlah Kemasan",
      "type": "number"
    },
    domProps: {
      "value": (_vm.headerTransit.jumlahKemasan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headerTransit.jumlahKemasan = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jumlah Kemasan')),
      expression: "errors.has('Jumlah Kemasan')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Jumlah Kemasan')) + " ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Kemasan"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headerTransit.jenisKemasan),
      expression: "headerTransit.jenisKemasan"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Jenis Kemasan",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.headerTransit.jenisKemasan = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.refKemasan), function(kemasan) {
    return _c('option', {
      domProps: {
        "value": kemasan.JNS_KMS
      }
    }, [_vm._v(" " + _vm._s(kemasan.JNS_KMS) + " - " + _vm._s(kemasan.UR_KMS) + " ")])
  })], 2), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Kemasan')),
      expression: "errors.has('Jenis Kemasan')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Jenis Kemasan')) + " ")])])], 1)])]), _vm._v(" "), _c('b-card', {
    attrs: {
      "header": "<i class='fa fa-cube'></i> Data Barang"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('p', [_c('i', {
    staticClass: "fa fa-th-list"
  }), _vm._v(" List Barang")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-danger pull-left",
    on: {
      "click": _vm.deleteAll
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  }), _vm._v(" Delete All")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-add",
      modifiers: {
        "collapse-add": true
      }
    }],
    staticClass: "btn btn-primary"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add")])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-4"
  }, [_c('table', {
    staticClass: "table table-bordered table-responsive"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "1%",
      "scope": "col"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "",
      "scope": "col"
    }
  }, [_vm._v("Nama Pesawat")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "15%",
      "scope": "col"
    }
  }, [_vm._v("Nomor Penerbangan")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "15%",
      "scope": "col"
    }
  }, [_vm._v("Nomor SMU")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "9%",
      "scope": "col"
    }
  }, [_vm._v("Jumlah")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "9%",
      "scope": "col"
    }
  }, [_vm._v("Berat")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "12%%",
      "scope": "col"
    }
  }, [_vm._v("Aksi")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.headerTransit.tableDetail), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(" " + _vm._s(index + 1) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(data.namaPesawat) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(data.noPenerbangan) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(data.noSmu) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(data.jumlahBarang) + " " + _vm._s(data.satuanBarang) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(data.berat) + " kg ")]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "title": "delete"
      },
      on: {
        "click": _vm.deleteGoods
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })]), _vm._v(" "), _c('button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: (("collapse-edit " + index)),
        expression: "`collapse-edit ${index}`"
      }],
      staticClass: "btn btn-secondary",
      attrs: {
        "title": "edit"
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })])])])
  }))])]), _vm._v(" "), _c('div', [_c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "collapse-add"
    }
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-edit'></i> Tambah Barang"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-11"
  }, [_c('b-form-fieldset', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailTransit.namaPesawat),
      expression: "detailTransit.namaPesawat"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Nama Sarkut",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.detailTransit.namaPesawat = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Nama Pesawat / Kapal")]), _vm._v(" "), _vm._l((_vm.refSarkut), function(nama) {
    return _c('option', {
      domProps: {
        "value": nama.nama_sarkut
      }
    }, [_vm._v(" " + _vm._s(nama.nama_sarkut) + " ")])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-1"
  }, [_c('b-form-fieldset', [_c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.tambah-kapal",
      modifiers: {
        "tambah-kapal": true
      }
    }],
    staticClass: "btn btn-success",
    attrs: {
      "title": "Tambah Nama Pesawat / Kapal"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailTransit.noPenerbangan),
      expression: "detailTransit.noPenerbangan"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Nomor Penerbangan"
    },
    domProps: {
      "value": (_vm.detailTransit.noPenerbangan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.detailTransit.noPenerbangan = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailTransit.noSmu),
      expression: "detailTransit.noSmu"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "No. SMU"
    },
    domProps: {
      "value": (_vm.detailTransit.noSmu)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.detailTransit.noSmu = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailTransit.jumlahBarang),
      expression: "detailTransit.jumlahBarang"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Jumlah Barang"
    },
    domProps: {
      "value": (_vm.detailTransit.jumlahBarang)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.detailTransit.jumlahBarang = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailTransit.satuanBarang),
      expression: "detailTransit.satuanBarang"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Satuan Barang"
    },
    domProps: {
      "value": (_vm.detailTransit.satuanBarang)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.detailTransit.satuanBarang = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailTransit.berat),
      expression: "detailTransit.berat"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Berat (kg)"
    },
    domProps: {
      "value": (_vm.detailTransit.berat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.detailTransit.berat = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "mt-3 pull-right"
  }, [_c('button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-add",
      modifiers: {
        "collapse-add": true
      }
    }],
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.submitGoods
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-add",
      modifiers: {
        "collapse-add": true
      }
    }],
    staticClass: "btn btn-danger"
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Cancel")])])])])])], 1)], 1), _vm._v(" "), _c('div', _vm._l((_vm.headerTransit.tableDetail), function(data, index) {
    return _c('b-collapse', {
      key: index,
      staticClass: "mt-2",
      attrs: {
        "id": ("collapse-edit " + index)
      }
    }, [_c('b-card', {
      attrs: {
        "header": ("<i class='fa fa-edit'></i> Edit Barang " + (index+1) + " ")
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-6"
    }, [_c('b-form-fieldset', {
      attrs: {
        "label": "Nama Pesawat"
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-11"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.detailTransit.namaPesawat),
        expression: "detailTransit.namaPesawat"
      }],
      staticClass: "form-control",
      attrs: {
        "name": "Nama Sarkut",
        "id": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.detailTransit.namaPesawat = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Nama Pesawat / Kapal")]), _vm._v(" "), _vm._l((_vm.refSarkut), function(nama) {
      return _c('option', {
        domProps: {
          "value": nama.nama_sarkut
        }
      }, [_vm._v(" " + _vm._s(nama.nama_sarkut) + " ")])
    })], 2)]), _vm._v(" "), _c('div', {
      staticClass: "col-1"
    }, [_c('b-form-fieldset', [_c('button', {
      directives: [{
        name: "b-modal",
        rawName: "v-b-modal.tambah-kapal",
        modifiers: {
          "tambah-kapal": true
        }
      }],
      staticClass: "btn btn-success",
      attrs: {
        "title": "Tambah Nama Pesawat / Kapal"
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    })])])], 1)])])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-6"
    }, [_c('b-form-fieldset', {
      attrs: {
        "label": "Nomor Penerbangan"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.detailTransit.noPenerbangan),
        expression: "detailTransit.noPenerbangan"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": data.noPenerbangan,
        "type": "text"
      },
      domProps: {
        "value": (_vm.detailTransit.noPenerbangan)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.detailTransit.noPenerbangan = $event.target.value
        }
      }
    })])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "row mt-3"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('b-form-fieldset', {
      attrs: {
        "label": "Nomor SMU"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.detailTransit.noSmu),
        expression: "detailTransit.noSmu"
      }],
      staticClass: "detail form-control",
      attrs: {
        "placeholder": data.noSmu
      },
      domProps: {
        "value": (_vm.detailTransit.noSmu)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.detailTransit.noSmu = $event.target.value
        }
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('b-form-fieldset', {
      attrs: {
        "label": "Jumlah Barang"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.detailTransit.jumlahBarang),
        expression: "detailTransit.jumlahBarang"
      }],
      staticClass: "detail form-control",
      attrs: {
        "placeholder": data.jumlahBarang
      },
      domProps: {
        "value": (_vm.detailTransit.jumlahBarang)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.detailTransit.jumlahBarang = $event.target.value
        }
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('b-form-fieldset', {
      attrs: {
        "label": "Satuan Barang"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.detailTransit.satuanBarang),
        expression: "detailTransit.satuanBarang"
      }],
      staticClass: "detail form-control",
      attrs: {
        "placeholder": data.satuanBarang,
        "type": "text"
      },
      domProps: {
        "value": (_vm.detailTransit.satuanBarang)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.detailTransit.satuanBarang = $event.target.value
        }
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('b-form-fieldset', {
      attrs: {
        "label": "Berat (kg)"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.detailTransit.berat),
        expression: "detailTransit.berat"
      }],
      staticClass: "detail form-control",
      attrs: {
        "placeholder": data.berat
      },
      domProps: {
        "value": (_vm.detailTransit.berat)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.detailTransit.berat = $event.target.value
        }
      }
    })])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "mt-3 pull-right"
    }, [_c('button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: (("collapse-edit " + index)),
        expression: "`collapse-edit ${index}`"
      }],
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          _vm.saveEdit(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-save"
    }), _vm._v(" Save")]), _vm._v(" "), _c('button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: (("collapse-edit " + index)),
        expression: "`collapse-edit ${index}`"
      }],
      staticClass: "btn btn-danger"
    }, [_c('i', {
      staticClass: "fa fa-times"
    }), _vm._v(" Cancel")])])])], 1)
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-between"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('router-link', {
    attrs: {
      "to": '/login'
    }
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg"
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Cancel")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg pull-right",
    on: {
      "click": _vm.submitAll
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane"
  }), _vm._v(" Send")])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "id": "tambah-kapal",
      "title": "Tambah Nama Pesawat / Kapal"
    },
    model: {
      value: (_vm.modalRefSarkut),
      callback: function($$v) {
        _vm.modalRefSarkut = $$v
      },
      expression: "modalRefSarkut"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nama Pesawat / Kapal"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tambahRefSarkut.nama),
      expression: "tambahRefSarkut.nama"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-transform": "uppercase"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.tambahRefSarkut.nama)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tambahRefSarkut.nama = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right mt-2",
    on: {
      "click": function($event) {
        _vm.addNamaSarkut()
      }
    }
  }, [_vm._v("Tambah")])])], 1)], 1)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "mt-2"
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _c('strong', [_vm._v("Form")]), _vm._v(" Perizinan Barang Transit (Barang Kiriman)")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27359d12","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/transit/FormTransitA.vue
// module id = 393
// module chunks = 0